import React, { useContext } from "react";
import { ContextList } from "../listContext";
import "./styles.css";

// Номера страниц: текущая ±2, края всегда, пропуски — многоточием.
const buildPageNumbers = (currentPage, lastPage) => {
    const numbers = [];
    for (let page = 1; page <= lastPage; page += 1) {
        if (page === 1 || page === lastPage || Math.abs(page - currentPage) <= 2) {
            numbers.push(page);
        } else if (numbers[numbers.length - 1] !== '…') {
            numbers.push('…');
        }
    }
    return numbers;
};

export default function ListPagination() {
    const contextList = useContext(ContextList);
    const { currentPage, lastPage, setPage } = contextList;
    if (!lastPage || lastPage <= 1) return null;

    return <div className="list__pagination">
        <button
            className="list__pagination-item"
            disabled={currentPage <= 1}
            onClick={() => setPage(currentPage - 1)}
        >
            ‹
        </button>
        {buildPageNumbers(currentPage, lastPage).map((page, index) =>
            page === '…'
                ? <span key={`dots-${index}`} className="list__pagination-dots">…</span>
                : <button
                    key={page}
                    className={`list__pagination-item${page === currentPage ? ' list__pagination-item_active' : ''}`}
                    onClick={() => setPage(page)}
                >
                    {page}
                </button>
        )}
        <button
            className="list__pagination-item"
            disabled={currentPage >= lastPage}
            onClick={() => setPage(currentPage + 1)}
        >
            ›
        </button>
    </div>;
}
